import { apolloClient as client } from 'src/graphql/client/apollo-client';
import { BackupMembersDocument } from 'src/graphql/actions/backupMembers/backupMembers.query';
import { UsersDocument } from 'src/graphql/actions/user/users.query';

export const refetchBackupMembers = () => {
  client.cache.evict({ fieldName: 'backupMembers' });
  client.cache.gc();
  client.refetchQueries({
    include: [BackupMembersDocument],
  });
};

export const refetchUsers = () => {
  client.cache.evict({ fieldName: 'users' });
  client.cache.gc();
  client.refetchQueries({
    include: [UsersDocument],
  });
};
